import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Persistent but non-annoying upgrade banner for free tier users.
 * Dismissible per session (reappears next session).
 */
export default function UpgradeBanner({ tier }) {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const sessionDismissed = sessionStorage.getItem('prism_upgrade_banner_dismissed');
    if (sessionDismissed) setDismissed(true);
  }, []);

  if (tier !== 'FREE' || dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem('prism_upgrade_banner_dismissed', 'true');
    setDismissed(true);
  };

  return (
    <div className="bg-gradient-to-r from-prism-cyan/10 to-purple-500/10 border-b border-prism-border px-4 py-2 flex items-center justify-between">
      <p className="text-xs text-prism-text-secondary flex-1">
        <span className="text-prism-cyan font-medium">PRISM Free</span> — Unlock unlimited features starting at $9.99/mo
      </p>
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          onClick={() => navigate('/settings/billing')}
          className="text-xs text-prism-cyan font-medium hover:underline"
        >
          Upgrade
        </button>
        <button
          onClick={handleDismiss}
          className="text-prism-text-secondary hover:text-prism-text p-1"
          aria-label="Dismiss"
        >
          <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}
